import { LoggerFactory } from "../../../utilities/logger";

export class WindowOpener {
  static open(from: string, to: string, parameters: { [key: string]: string } = {}): void {
    const url = WindowOpener.toUrl(to, parameters);
    this.openWindow(url);
  }

  static openWindow(url: string): void {
    this._logger.debug("新しいWindowをopenします.");
    this._logger.debug(url);
    window.open(url, "");
  }

  private static toUrl(location: string, parameters: { [key: string]: string }): string {
    return location + WindowOpener.toParametersAsString(parameters);
  }

  private static toParametersAsString(parameters: { [key: string]: string }): string {
    const expressions = WindowOpener.toParameterExpressions(parameters);
    return (0 < expressions.length)
      ? "?" + expressions.join("&")
      : "";
  }

  private static toParameterExpressions(parameters: { [key: string]: string }): string[] {
    const results = [];
    for (const key of Object.keys(parameters)) {
      const value = parameters[key];
      if (!value || (value === "")) {
        continue;
      }
      results.push(key + "=" + parameters[key]);
    }
    return results;
  }

  private static readonly _logger = LoggerFactory.getLogger();
}
